var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ConfigAutorizacionesContenedor" },
    [
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("v-combobox", {
                attrs: {
                  label: "Usuario",
                  items: _vm.usuariosOptions,
                  "item-text": "nombrecompleto",
                  "item-value": "idusuario",
                  dense: ""
                },
                model: {
                  value: _vm.usuario,
                  callback: function($$v) {
                    _vm.usuario = $$v
                  },
                  expression: "usuario"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("v-combobox", {
                attrs: {
                  label: "Operación",
                  items: _vm.operacionesOptions,
                  "item-text": "configdescripcion",
                  "item-value": "configid",
                  dense: ""
                },
                model: {
                  value: _vm.operacion,
                  callback: function($$v) {
                    _vm.operacion = $$v
                  },
                  expression: "operacion"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Estado",
                  items: ["ACTIVO", "INACTIVO"],
                  clearable: "",
                  dense: ""
                },
                model: {
                  value: _vm.estadoSelected,
                  callback: function($$v) {
                    _vm.estadoSelected = $$v
                  },
                  expression: "estadoSelected"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { sm2: "", md2: "", "mt-2": "" } }, [
            _c(
              "div",
              { staticClass: "text-sm-center" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.handleFilters } },
                  [_c("v-icon", [_vm._v("search")]), _vm._v("FILTRAR")],
                  1
                ),
                _c(
                  "v-btn",
                  { on: { click: _vm.clearFilters } },
                  [_c("v-icon", [_vm._v("clear")]), _vm._v("LIMPIAR")],
                  1
                )
              ],
              1
            )
          ]),
          _c("v-flex", { attrs: { sm3: "", md3: "" } }, [
            _c("div", { staticClass: "text-sm-center" })
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "contenidoConfigAutorizaciones" },
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md4: "" } },
            [
              _c("v-text-field", {
                staticStyle: { "margin-right": "5px" },
                attrs: { label: "Buscar...", "append-icon": "search" },
                on: { input: _vm.handleSearch },
                model: {
                  value: _vm.filtrobusquedagrilla,
                  callback: function($$v) {
                    _vm.filtrobusquedagrilla = $$v
                  },
                  expression: "filtrobusquedagrilla"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { xs12: "", sm8: "", md5: "" } }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md4: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: { click: _vm.exportarExcel }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("  \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("CSV")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btnCrear",
                      on: {
                        click: function($event) {
                          _vm.abrirModalCrear = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "", left: "" } }, [
                        _vm._v("add_circle_outline")
                      ]),
                      _c("span", [_vm._v("CREAR")])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "ModalMantenedor",
            { attrs: { show: _vm.abrirModalCrear } },
            [
              _c(
                "CabeceraModalCreacion",
                {
                  attrs: { permitirGuard: _vm.permitirGuardCrear },
                  on: {
                    cerrarCrear: _vm.cerrarModalCrear,
                    guardarCrear: _vm.guardarAlta
                  }
                },
                [
                  _c("NavegacionModalCrud", {
                    attrs: {
                      pasos: _vm.pasosCrear,
                      "estado-id": _vm.estadoIdCrear
                    },
                    on: { guardar: _vm.guardarAlta },
                    model: {
                      value: _vm.pasoActivoIndexCrear,
                      callback: function($$v) {
                        _vm.pasoActivoIndexCrear = $$v
                      },
                      expression: "pasoActivoIndexCrear"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-stepper",
                {
                  model: {
                    value: _vm.pasoActivoIndexCrear,
                    callback: function($$v) {
                      _vm.pasoActivoIndexCrear = $$v
                    },
                    expression: "pasoActivoIndexCrear"
                  }
                },
                [
                  _c("CrudStepperHeader", {
                    attrs: {
                      pasos: _vm.pasosCrear,
                      "paso-activo-index": _vm.pasoActivoIndexCrear
                    }
                  }),
                  _c(
                    "CrudStepperItems",
                    [
                      _c(
                        "CrudStepperContent",
                        { attrs: { paso: _vm.pasosCrear.configuracion } },
                        [
                          _c("ComponenteForm", {
                            attrs: {
                              listaOperaciones: _vm.operacionesOptions,
                              creacion: true
                            },
                            on: { objCreacion: _vm.objsParaAlta }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "ModalMantenedor",
                { attrs: { show: _vm.abrirModalEditar } },
                [
                  _c(
                    "CabeceraModalEdicion",
                    {
                      attrs: { permitirGuard: _vm.permitirGuardEditar },
                      on: {
                        cerrarEditar: _vm.cerrarModalEditar,
                        guardarCrear: _vm.guardarEdicion
                      }
                    },
                    [
                      _c("NavegacionModalCrud", {
                        attrs: {
                          pasos: _vm.pasosEditar,
                          "estado-id": _vm.estadoIdEditar
                        },
                        model: {
                          value: _vm.pasoActivoIndexEditar,
                          callback: function($$v) {
                            _vm.pasoActivoIndexEditar = $$v
                          },
                          expression: "pasoActivoIndexEditar"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-stepper",
                    {
                      model: {
                        value: _vm.pasoActivoIndexEditar,
                        callback: function($$v) {
                          _vm.pasoActivoIndexEditar = $$v
                        },
                        expression: "pasoActivoIndexEditar"
                      }
                    },
                    [
                      _c("CrudStepperHeader", {
                        attrs: {
                          pasos: _vm.pasosEditar,
                          "paso-activo-index": _vm.pasoActivoIndexEditar
                        }
                      }),
                      _c(
                        "CrudStepperItems",
                        [
                          _c(
                            "CrudStepperContent",
                            { attrs: { paso: _vm.pasosEditar.configuracion } },
                            [
                              _c("ComponenteForm", {
                                attrs: {
                                  listaOperaciones: _vm.operacionesOptions,
                                  edicion: true,
                                  data: _vm.infoEdicion
                                },
                                on: { objEdicion: _vm.objsParaEdicion }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "ModalMantenedor",
                { attrs: { show: _vm.abrirModalVer } },
                [
                  _c(
                    "CabeceraModalVisualizacion",
                    { on: { cerrarVer: _vm.cerrarModalVer } },
                    [
                      _c("NavegacionModalCrud", {
                        attrs: {
                          pasos: _vm.pasosVisualizar,
                          "estado-id": _vm.estadoIdVer
                        },
                        model: {
                          value: _vm.pasoActivoIndexVer,
                          callback: function($$v) {
                            _vm.pasoActivoIndexVer = $$v
                          },
                          expression: "pasoActivoIndexVer"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-stepper",
                    {
                      model: {
                        value: _vm.pasoActivoIndexVer,
                        callback: function($$v) {
                          _vm.pasoActivoIndexVer = $$v
                        },
                        expression: "pasoActivoIndexVer"
                      }
                    },
                    [
                      _c("CrudStepperHeader", {
                        attrs: {
                          pasos: _vm.pasosVisualizar,
                          "paso-activo-index": _vm.pasoActivoIndexVer
                        }
                      }),
                      _c(
                        "CrudStepperItems",
                        [
                          _c(
                            "CrudStepperContent",
                            {
                              attrs: { paso: _vm.pasosVisualizar.configuracion }
                            },
                            [
                              _c("ComponenteForm", {
                                attrs: {
                                  visualizacion: true,
                                  data: _vm.infoVisualizacion
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.mostrarModalHistorial
            ? _c("ModalVerHistorial", {
                attrs: { autoId: _vm.numeroconfig },
                on: {
                  cerrar: function($event) {
                    _vm.mostrarModalHistorial = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad,
              id: "tabla"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }